<template>
  <md-menu
    ref="menuCtrl"
    md-size="auto"
    md-direction="top-start"
    :md-close-on-click="true"
    :md-offset-x="10"
    :md-offset-y="8"
  >
    <md-button md-menu-trigger :class="['actions-button', typeClass]">
      <help-tooltip :type="type" invert />
      <span>{{ notificationCount }}! Click for more.</span>
    </md-button>
    <md-menu-content>
      <div class="flyout-header">
        <h3 class="flyout-header-title">{{ title }}s</h3>
        <p class="flyout-header-subtitle">{{ subtitle }}</p>
      </div>
      <div
        v-for="(notif, index) in notifications"
        :key="index"
        :class="['flyout-item', typeClass]"
        @click="open(notif)"
      >
        <span class="notiication-message">{{ notif.message }}</span>
        <div>
          <span v-if="type === 'warning'" class="flyout-item-link" @click.stop="dismiss(notif)">DISMISS</span>
          <span class="flyout-item-link">GO TO</span>
        </div>
      </div>
    </md-menu-content>
  </md-menu>
</template>

<script>
import HelpTooltip from '~lib/common/components/HelpTooltip.vue';

export default {
  name: 'notification-menu',
  components: {
    HelpTooltip
  },
  props: {
    notifications: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      default: 'info',
    },
    subtitle: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    title() {
      if (this.type === 'warning') {
        return 'Warning';
      } else if (this.type === 'error') {
        return 'Error';
      }
      return 'Info';
    },
    notificationCount() {
      const num = this.notifications.length;
      const suffix = num > 1 ? 's' : '';
      return `${num} ${this.title}${suffix}`;
    },
    typeClass() {
      return `${this.type}-button`;
    },
  },
  watch: {
    // eslint-disable-next-line no-unused-vars
    notifications(newValue) {
      if (newValue.length === 0) {
        // Force hide of the menu content
        this.$refs.menuCtrl.MdMenu.active = false;
      }
    },
  },
  methods: {
    open(notification) {
      this.$emit('open', notification);
    },
    dismiss(notification) {
      this.$emit('dismiss', notification);
    },
  },
};
</script>

<style scoped>

.flyout-header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  line-height: normal;
}

.flyout-header-title {
  margin: 4px 16px 0px;
}

.flyout-header-subtitle {
  margin: 4px 16px 8px;
}

.md-menu-content {
  max-width: 600px;
  width: 600px;
  max-height: 200px;
  font-size: 12px;
}

.flyout-item {
  padding: 8px;
  font-size: 12px;
  font-weight: 400;
  color: white;
  margin: 4px 16px 8px;
  cursor: pointer;
  border-radius: 4px;
  box-shadow: 1px 1px 4px 0 rgba(0,0,0,.4);
  display: flex;
  justify-content: space-between;
}

.flyout-item-link {
  margin-right: 8px;
  color: #ffffff !important;
}

.flyout-item-link:last-child {
  margin-right: 0;
}

.flyout-item-link:hover {
  text-decoration: underline;
}

.error-button .icon,
.warning-button .icon {
  color: #ffffff !important;
  margin: 0px 8px;
}

.close-button {
  margin: 0 0 0 auto;
}
.close-button i {
  font-size: 22px !important;
}

.actions-button {
  margin-left: 10px;
  margin-right: 10px;
  padding-right: 10px;
  font-size: 15px;
  font-weight: 500;
  color: white;
  height: 40px;
  border-radius: 5px;
}

.info-button {
  background-color: #3f83c5;
}

.error-button {
  background-color: #f92c2d;
}

.warning-button {
  background-color: #f2994a;
}

.notification-message {
  white-space: normal;
}
</style>
